// Yazio-style funnel flow
export const ONBOARDING_STEPS = [
  // Section 1: Goals & Motivation
  "chooseGoal",
  "mainGoal",
  "goalReason",
  "additionalGoals",
  "socialProof",

  // Section 2: Experience
  "weightLossAttempts",
  "restrictiveDiets",
  "sustainableApproach",
  "pastChallenges",
  "challengesOvercome",

  // Section 3: Understanding You
  "weightGainCauses",
  "pastChanges",
  "whatsDifferent",
  "motivational1",
  "keyToSuccess",
  "motivational2",

  // Section 4: Nutrition & Tracking
  "nutritionGoal",
  "calorieCountingExperience",
  "calorieCountingPositive",
  "howCountedCalories",
  "valueProp",
  "aiFeature",

  // Section 5: Lifestyle
  "waterIntake",
  "stayOnTrack",
  "howFeeling",

  // Section 6: Your Body
  "height",
  "weight",
  "goalWeight",
  "age",
  "activityLevel",
  "speedGoal",
  "wellnessSnapshot",
  "lookForwardTo",
  "progressPlan",

  // Section 7: Account Creation
  "password",
  "email",
] as const

export const ONBOARDING_SECTIONS = [
  {
    name: "Goals",
    steps: [
      "chooseGoal",
      "mainGoal",
      "goalReason",
      "additionalGoals",
      "socialProof",
    ],
  },
  {
    name: "Experience",
    steps: [
      "weightLossAttempts",
      "restrictiveDiets",
      "sustainableApproach",
      "pastChallenges",
      "challengesOvercome",
    ],
  },
  {
    name: "Understanding You",
    steps: [
      "weightGainCauses",
      "pastChanges",
      "whatsDifferent",
      "motivational1",
      "keyToSuccess",
      "motivational2",
    ],
  },
  {
    name: "Nutrition & Tracking",
    steps: [
      "nutritionGoal",
      "calorieCountingExperience",
      "calorieCountingPositive",
      "howCountedCalories",
      "valueProp",
      "aiFeature",
    ],
  },
  {
    name: "Lifestyle",
    steps: ["waterIntake", "stayOnTrack", "howFeeling"],
  },
  {
    name: "Your Body",
    steps: [
      "height",
      "weight",
      "goalWeight",
      "age",
      "activityLevel",
      "speedGoal",
      "wellnessSnapshot",
      "lookForwardTo",
      "progressPlan",
    ],
  },
  {
    name: "Create Account",
    steps: ["password", "email"],
  },
] as const
